<template>
  <div class="d-flex flex-column align-items-center page-wrapper">
    <img :src="require(`../brand/${this.brandConfig.brand}/assets/evina-img.webp`)" class="w-100">
    <div class="header-text mt-3">
      {{ this.brandConfig.errorText }}
    </div>
    <div class="terms-and-conditions mt-4">
      Terms & Conditions
    </div>
    <button class="accept-btn" @click="onRetryClicked">Retry</button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {triggerGTMEvent} from "@/functions/addGTM";

export default {
  computed: {
    ...mapState(['brandConfig'])
  },
  methods: {
    async onRetryClicked() {
      triggerGTMEvent('retry_button_clicked');
      this.$router.push('/');
    }
  },
  async mounted() {
    triggerGTMEvent('error_page_view');
    const urlParams = new URLSearchParams(window.location.search);
    const errorCode = urlParams.get('epgw_status');
    if (errorCode.toString() === '900' || errorCode.toString() === '800') window.location.href = `${this.brandConfig.gameUrl}`;
  }
}
</script>

<style scoped>
.page-wrapper {
  height: 100vh;
}

.header-text {
  color: #FFFFFF;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
}


.terms-and-conditions {
  color: #FFFFFF;
  text-align: center;
  font-size: 0.7rem;
  text-decoration: underline;
}

.accept-btn {
  background-color: limegreen;
  color: #FFFFFF;
}

h1 {
  margin-bottom: 0.5rem;
  color: #333;
}

p {
  color: #666;
  line-height: 1.6;
}

button {
  padding: 15px 30px;
  font-size: 1.4rem;
  cursor: pointer;
  margin-top: 1.5rem;
  transition: background-color 0.3s, transform 0.2s;
  width: 80%;
  border: none;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-message p {
  margin: 0;
  color: #c62828;
}
</style>